import axios from 'axios';

// Determine API URL based on environment
const getApiUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'https://dev-api.fundmewiz.com';
  } else if (hostname.includes('dev.')) {
    return import.meta.env.VITE_API_URL || 'https://dev-api.fundmewiz.com';
  }
  return import.meta.env.VITE_API_URL || 'https://api.fundmewiz.com';
};

const api = axios.create({
  baseURL: getApiUrl(),
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status, config } = error.response;

      // Don't redirect for auth-related endpoints
      const authEndpoints = [
        '/auth/login',
        '/auth/register',
        '/sponsor/login',
        '/admin-panel/login'
      ];
      const isAuthEndpoint = authEndpoints.some(endpoint => config.url?.includes(endpoint));

      if (status === 401 && !isAuthEndpoint) {
        // Unauthorized - clear auth and redirect to login
        const currentUserType = localStorage.getItem('userType');

        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('userType');
        localStorage.removeItem('user');

        if (currentUserType === 'admin') {
          window.location.href = '/admin-panel/login';
        } else {
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
